import Label from './Label'
import LabelHint from './LabelHint'

Label.Hint = LabelHint

export default Label
